var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullseye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_11179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 5.73838L12.6055 3.75947C12.5391 3.36143 12.668 2.95557 12.9531 2.67041L14.9531 0.670411C15.2383 0.353067 15.8086 0.463379 15.9766 0.880176L16.875 3.1251L19.1211 3.98838C19.5352 4.1915 19.6133 4.72666 19.3281 5.04697L17.3281 7.04697C17.043 7.33213 16.6367 7.42588 16.2422 7.39463L14.2617 7.0626L10.6289 10.629C10.2969 11.0274 9.70312 11.0274 9.33594 10.629C8.97266 10.297 8.97266 9.70322 9.33594 9.33603L12.9375 5.73838Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.3125 8.33984L15.4297 8.52734C15.5586 8.99609 15.625 9.48828 15.625 10C15.625 13.1055 13.1055 15.625 10 15.625C6.89453 15.625 4.375 13.1055 4.375 10C4.375 6.89453 6.89453 4.375 10 4.375C10.5117 4.375 11.0039 4.44141 11.4727 4.53516L11.6602 5.6875L10.4414 6.90625C10.2969 6.88672 10.1484 6.83984 10 6.83984C8.27344 6.83984 6.875 8.27344 6.875 9.96484C6.875 11.7266 8.27344 13.125 10 13.125C11.7266 13.125 13.125 11.7266 13.125 9.96484C13.125 9.85156 13.1133 9.70312 13.0938 9.55859L14.3125 8.33984ZM19.4414 6.69922C19.7695 7.69922 20 8.84375 20 10C20 15.5234 15.5234 20 10 20C4.47656 20 0 15.5234 0 10C0 4.47656 4.47656 0 10 0C11.1562 0 12.2656 0.19625 13.3008 0.557422L11.2539 2.6043C10.8438 2.53555 10.4258 2.5 10 2.5C5.82422 2.5 2.5 5.82422 2.5 10C2.5 14.1406 5.82422 17.5 10 17.5C14.1406 17.5 17.5 14.1406 17.5 10C17.5 9.57422 17.4648 9.15625 17.3945 8.74609L19.4414 6.69922Z",
    fill: "#0066FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_11179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseye);
export default __webpack_public_path__ + "static/media/bullseye.532d977156e5de15509069534a894447.svg";
export { ForwardRef as ReactComponent };